(function () {
    $(function () {
        const defaults = {
            blinkTimeout: 50,
            errorText: 'Некорректное значение'
        }
        
        $(document).on('focus', '.ui-input-custom__input', event => {
            const target = event.target
            const rootElement = target.closest('.ui-input-custom')
            const customEvent = new Event('inputFocused', {bubbles: true})
            rootElement.dispatchEvent(customEvent)
        })
        $(document).on('blur', '.ui-input-custom__input', event => {
            const target = event.target
            const rootElement = target.closest('.ui-input-custom')
            const customEvent = new Event('inputBlurred', {bubbles: true})
            rootElement.dispatchEvent(customEvent)
        })
        $(document).on('inputFocused', '.ui-input-custom', event => {
            $(event.target).addClass('ui-input-custom_focused')
        })
        $(document).on('inputBlurred', '.ui-input-custom', event => {
            $(event.target).removeClass('ui-input-custom_focused')
        })
        // todo сделать добавление ошибки в блок по передаваемому селектору ?
        $(document).on('inputError', '.ui-input-custom__input', (event, data) => {
            const $inputWrap = $(event.target).closest('.ui-input-custom')
            $inputWrap.siblings('.ui-input-error').remove()
            const $error = $(`<div class="ui-input-error">${data.text}</div>`)
            $inputWrap.addClass('ui-input-custom_state-error').after($error)
            setTimeout(() => {
                $error.addClass('ui-input-error_state-visible')
            }, defaults.blinkTimeout)
            
        })
        $(document).on('inputResolveErrors', '.ui-input-custom__input', event => {
            const $inputWrap = $(event.target).closest('.ui-input-custom')
            $inputWrap.removeClass('ui-input-custom_state-error').siblings('.ui-input-error').remove()
        })
        $(document).on('inputDoAble', '.ui-input-custom', event => {
            $(event.target).removeClass('ui-input-custom_disabled').find('.ui-input-custom__input').prop('disabled', false)
        })
        $(document).on('inputDoDisable', '.ui-input-custom', event => {
            $(event.target).addClass('ui-input-custom_disabled').find('.ui-input-custom__input').prop('disabled', true)
        })
        // todo сделать добавление ошибки в блок по передаваемому селектору ?
        // todo скорректировать на событие по блоку .ui-input-custom
        $(document).on('inputError', '.ui-input-custom__input', (event, data) => {
            const $inputWrap = $(event.target).closest('.ui-input-custom')
            $inputWrap.siblings('.ui-input-error').remove()
            const $error = $(`<div class="ui-input-error">${(data && data.text) ? data.text : defaults.errorText}</div>`)
            $inputWrap.addClass('ui-input-custom_state-error').after($error)
            if (data && data.code) {
                $inputWrap.attr('data-error-code', data.code)
            }
            setTimeout(() => {
                $error.addClass('ui-input-error_state-visible')
            }, defaults.blinkTimeout)
        
        })
        $(document).on('inputResolveErrors', '.ui-input-custom__input', event => {
            const $inputWrap = $(event.target).closest('.ui-input-custom')
            $inputWrap.removeClass('ui-input-custom_state-error').removeAttr('data-error-code').siblings('.ui-input-error').remove()
        })
    })
}());
